export default __webpack_public_path__ + "static/media/spinWheelPin.da67a725.png";